// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"363":"7488bdf4","421":"cfa74a86","480":"9ff34f87"}[chunkId] + ".chunk.js";
};